import { defineMessages } from 'react-intl';

export const i18n: {
	liveSearchLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	liveSearchTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	liveSearchSelectSearchMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	liveSearchSelectNoResult1: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	liveSearchSelectNoResult2: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	liveSearchLabel: {
		id: 'live-search.label',
		defaultMessage: 'Search',
		description: 'Accessible label for the live search trigger button',
	},
	liveSearchTooltip: {
		id: 'live-search.tooltip',
		defaultMessage: 'Live Search Macro',
		description: 'Tooltip shown for the Live Search macro in the editor',
	},
	liveSearchSelectSearchMore: {
		id: 'live-search.search-more',
		defaultMessage: 'See more search results',
		description: 'Label for live search dropdown search more button',
	},
	liveSearchSelectNoResult1: {
		id: 'live-search.no-result-1',
		defaultMessage: 'We couldn’t find anything matching your search',
		description: 'Label for live search dropdown no result line 1',
	},
	liveSearchSelectNoResult2: {
		id: 'live-search.no-result-2',
		defaultMessage: 'Try again with a different term',
		description: 'Label for live search dropdown no result line 2',
	},
	searchIconLabel: {
		id: 'live-search.search-icon-label',
		defaultMessage: 'Magnifying glass',
		description: 'Alt/label text for magnifying glass image or icon',
	},
});
